export const ALREADY_CLAIMED = 'once the invite credit has been claimed the referrer cannot be changed';
export const REFERRER_NOT_FOUND = 'A odysee account could not be found for the referrer you provided.';
export const PUBLISH_TIMEOUT_BUT_LIKELY_SUCCESSFUL = 'There was a network error, but the publish may have been completed. Wait a few minutes, then check your Uploads or Wallet page to confirm.';
export const SDK_FETCH_TIMEOUT = 'Your action timed out, but may have been completed.';
export const SDK_LEDGER_TRANSACTION_TIMEOUT = 'Timed out waiting for transaction.';
export const FETCH_TIMEOUT = 'promise timeout';
export const RESTRICTED_CONTENT_PUBLISHING_FAILED = 'There was a network error, but the publish may have been completed. Wait a few minutes, then check your Uploads or Wallet page to confirm.\n\nIf the publish was successful, please verify the member restrictions (e.g. through Incognito), as it might not be applied correctly. If so, please re-upload (Edit) the content.';

export const ERR_GRP = {
  TUS: 'publish-v2',
  VIDEOJS: 'video.js',
};
